import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'
import Cookies from 'universal-cookie';
import { isIdleLogoutHome } from './common/Funcation';
const cookies = new Cookies()

const PrivateRoute = ({ children }: any) => {
    const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
    const authToken = cookies.get('skyTokenFront')
    if (authToken) return children;
    // Idle-timeout logout only: send guests home, not /login. Other auth losses still go to login.
    if (isIdleLogoutHome()) return <Navigate to="/" replace />;
    return <Navigate to="/login" />;
    // return isAuthenticated?.isLogin && authToken ? children : <Navigate to="/#login" />;
}

export default PrivateRoute